import React, { Component } from "react"
import Slider from "react-slick";
import Tilt from 'react-parallax-tilt';

import Helmet from "react-helmet"
import { withPrefix, Link } from "gatsby"

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/style.css"

import Airtable from 'airtable'
const base = new Airtable({ apiKey: 'keyZwQwIDtkQ3t4UV' }).base('appsqEtsoErgljH4Q');



class homeSlider extends Component {

    constructor(props) {
        super(props);
        this.state = {
            slides: []
        }
    }

    componentDidMount() {
        try {
            base('Home Slider').select({ view: 'All Slides' })
                .eachPage(
                    (records, fetchNextPage) => {
                        const slides = records.map(slide => {
                            // console.log('slide', slide)
                            return slide
                        })
                        this.setState({
                            slides
                        });
                        fetchNextPage();
                    }
                );
        } catch (err) {
            console.error(err)
        }
    }
    

    render() {

        function SlickNextArrow(props) {
            const { className, style, onClick } = props;
            return (
                <div
                className={className}
                style={{ ...style, display: "block" }}
                onClick={onClick}
                >
                    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.9359 46L9.12625 41.1903L27.2549 23.185L9.00293 4.80965L13.8126 0L32.1879 18.4987L36.9976 23.3083L13.9359 46Z" fill="#BDBDBD"/>
                    </svg>
                </div>
            );
        }
        
        function SlickPrevArrow(props) {
            const { className, style, onClick } = props;
            return (
                <div
                className={className}
                style={{ ...style, display: "block" }}
                onClick={onClick}
                >
                    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M32.163 0L36.9598 4.79679L18.6336 23.246L36.7138 41.2032L31.917 46L9.04004 23.246L13.8368 18.4492L32.163 0Z" fill="#BDBDBD"/>
                    </svg>
                </div>
            );
        }

        const settings = {
            className: "broken-grid",
            centerMode: false,
            infinite: true,
            centerPadding: "60px",
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 800,
            autoplaySpeed:10000,
            autoplay: true,
            dots:true,
            draggable:true,
            adaptiveHeight: false,
            nextArrow: <SlickNextArrow />,
            prevArrow: <SlickPrevArrow />
        };
        return (
            <div className="sizing-ratio-16-9">
                <Helmet>
                    {/* <script src={withPrefix('iframeresize.js')} type="text/javascript" /> */}
                </Helmet>
                <Slider {...settings}>
                    {this.state.slides.map(slide => {
                        let slideImg, bgImg, articleCount = null;
                        let articles = {};
                        if (slide.fields['Slide Image']) {
                            slideImg = slide.fields['Slide Image'][0].url;
                        }
                        if (slide.fields['Background Image']) {
                            bgImg = slide.fields['Background Image'][0].url;
                        }
                        if (slide.fields['Article 1 Image']) {
                            articles['1'] = {
                                image : slide.fields['Article 1 Image'][0].url,
                                text : slide.fields['Article 1 Text'],
                                link : slide.fields['Article 1 Link']
                            }
                        }
                        if (slide.fields['Article 2 Image']) {
                            articles['2'] = {
                                image : slide.fields['Article 2 Image'][0].url,
                                text : slide.fields['Article 2 Text'],
                                link : slide.fields['Article 2 Link']
                            }
                        }
                        if (slide.fields['Article 3 Image']) {
                            articles['3'] = {
                                image : slide.fields['Article 3 Image'][0].url,
                                text : slide.fields['Article 3 Text'],
                                link : slide.fields['Article 3 Link']
                            }
                        }
                        articleCount = Object.keys(articles).length;
                        // console.log(articles);
                        return (
                            <div className={`broken-grid__slide articles-${articleCount}`} key={slide.id}>
                                <div className="broken-grid__bg" style={{backgroundImage: `url("${bgImg}")`}}>
                                    {/* <img src={bgImg} /> */}
                                </div>
                                
                                <div className="broken-grid__content-wrapper">
                                <Tilt className="parallax-effect" 
                                    trackOnWindow={true} 
                                    perspective={1000} 
                                    transitionSpeed={50} 
                                    transitionEasing={10}
                                    tiltMaxAngleX={7}
                                    tiltMaxAngleY={7}
                                    reset={false}
                                    >
                                    <div className="broken-grid__content">
                                        <h2 className={`broken-grid__title slide-${slide.fields.Color}`}>{slide.fields.Name}</h2>
                                        <p className="broken-grid__desc">
                                            <span className="broken-grid__desc-copy">{slide.fields.Description}</span>
                                            <a href={slide.fields.Link} target="_blank"> 
                                                <span className="broken-grid__arrow">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0)"><path d="M8.97587 0C10.2306 0 11.3887 0.241287 12.4987 0.675603C13.6086 1.15818 14.5737 1.78552 15.3941 2.6059C16.2145 3.42627 16.8418 4.39142 17.3244 5.50134C17.807 6.61126 18.0483 7.76944 18.0483 9.02413C18.0483 10.2788 17.807 11.437 17.3244 12.5469C16.8418 13.6568 16.2145 14.5737 15.3941 15.3941C14.5737 16.2145 13.6086 16.8418 12.4987 17.3244C11.3887 17.807 10.2306 18.0483 9.02413 18.0483C7.76944 18.0483 6.61126 17.807 5.50134 17.3244C4.39142 16.8418 3.42627 16.2145 2.6059 15.3941C1.78552 14.5737 1.15818 13.6086 0.675603 12.5469C0.193029 11.437 0 10.2788 0 9.02413C0 7.76944 0.241287 6.61126 0.675603 5.50134C1.15818 4.39142 1.78552 3.42627 2.6059 2.6059C3.42627 1.78552 4.39142 1.15818 5.50134 0.675603C6.61126 0.241287 7.76944 0 8.97587 0ZM12.1609 10.2306L13.3673 9.07239L7.67292 3.37802L6.46649 4.58445L10.9544 9.02413L6.41823 13.6086L7.62466 14.815L12.1609 10.2306Z" fill="#21A0D2"/></g><defs><clipPath id="clip0"><rect width="18" height="18" fill="white"/></clipPath></defs></svg>
                                                </span>
                                                <span className="broken-grid__desc-link">{slide.fields['Link Title']}</span>
                                            </a>
                                        </p>
                                    </div>
                                    { articleCount > 0 ? 
                                        <a className="broken-grid__article article-1" href={articles["1"].link} target="_blank">
                                            <img className="broken-grid__img" src={articles["1"].image} />
                                            { articles["1"].text ? 
                                                <div className="broken-grid__article-text">
                                                  { articles["1"].text }
                                                </div>
                                                : null
                                            }
                                        </a>
                                      : null 
                                    }
                                    { articleCount > 1 ? 
                                        <a className="broken-grid__article article-2" href={articles["2"].link} target="_blank"> 
                                            <img className="broken-grid__img" src={articles["2"].image} />
                                            { articles["2"].text ? 
                                                <div className="broken-grid__article-text">
                                                  { articles["2"].text }
                                                </div>
                                                : null
                                            }
                                        </a> 
                                      : null 
                                    }
                                    { articleCount > 2 ? 
                                        <a className="broken-grid__article article-3" href={articles["3"].link} target="_blank">
                                            <img className="broken-grid__img" src={articles["3"].image} />
                                            { articles["3"].text ? 
                                                <div className="broken-grid__article-text">
                                                  { articles["3"].text }
                                                </div>
                                                : null
                                            }
                                        </a>
                                      : null 
                                    }

                                    
                                </Tilt>
                                </div>
                              
                               
                            </div>
                        )
                    })}
                </Slider> 
            </div>
        );
    }
}

export default homeSlider